import { useEffect } from "react";
import useWindowSize from "../../../../hooks/useWindowSize";
import { func } from "../../../../utils";
import {
  Button,
  Card,
  Container,
  HighlightedDate,
  Icon,
  InnerCardContainer,
  Stroke,
  SubtitleCard,
  TitleCard,
} from "./CityListPopup.styled";
import moment from "moment";
import { SelectionCityRegistration } from "../../../../pages/v2/Registration/RegistrationPage.styled";
import { useCitySchool } from "../../../../store/user";
import { useFetchRegionEventSeries } from "../../../../networks";
import { capitalizeFLetter } from "../../../../utils/function";
import { usePageContextFunction } from "../../../../context/PageContext";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const CityListPopup = ({ data = [] }) => {
  const { size } = useWindowSize();
  const isMobileView = (size?.width || 0) <= 768;
  const { setCitySchool } = useCitySchool();
  const { data: dataRaw, isFetching: fetchingEventRegion } =
    useFetchRegionEventSeries();
  const { setOpenPopUp: togglePopUp } = usePageContextFunction();
  const dataRegistCity =
    dataRaw?.data?.data?.eventSeries?.filter(
      (val) => !val?.registration_url && val?.is_registration_open
    ) || [];
  //get item status === 1 or last item
  const activeItem = data?.find((item) => item.status === 1)
    ? data.find((item) => item.status === 1)
    : data?.[data?.length - 1];
  const indexActiveItem = data?.findIndex((item) => item.status === 1);

  const dataFinal = data?.map((val, i) => {
    return {
      ...val,
      isDone: i < indexActiveItem,
      isActive: i <= indexActiveItem,
    };
  });

  const lastDate = data?.[data?.length - 1]?.end_date;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        margin: "0 auto",
        maxWidth: isMobileView ? "100%" : "fit-content",
      }}
    >
      <Container style={{ gap: 8 }}>
        {dataRegistCity?.map((val, i) => {
          const startDate = moment(val?.event_start_date);
          const endDate = moment(val?.event_end_date);

          const isSameMonthEvent =
            startDate.format("MMMM") === endDate.format("MMMM");
          const cardDate = isSameMonthEvent
            ? `${startDate?.format("D")} - ${endDate?.format("D MMMM YYYY")}`
            : `${startDate?.format("D MMMM")} - ${endDate?.format(
                "D MMMM YYYY"
              )}`;

          return (
            <SelectionCityRegistration
              key={i}
              className="md:h-[auto]"
              justifyContent={"inherit"}
              onClick={() => {
                setCitySchool({
                  ...val,
                  cardDate,
                  region_name: capitalizeFLetter(
                    String(val?.region_name)?.toLowerCase()
                  ),
                });
                togglePopUp(false);
              }}
              background={`url(${func.getStaticImg(
                "/illustration/swoosh-blue-right.svg"
              )}) white`}
            >
              <img
                style={{ width: 56, height: 45.5, marginRight: 16 }}
                src={`${imgPath}${val?.region_logo}`}
                alt="icon"
              />
              <div style={{ flexDirection: "column", display: "flex" }}>
                <b style={{ fontSize: 18, letterSpacing: 0.09 }}>
                  {capitalizeFLetter(String(val?.region_name)?.toLowerCase())}
                </b>
                <b
                  style={{
                    fontSize: 13,
                    color: "#6A7481",
                    margin: "4px 0 2px 0",
                  }}
                >
                  {cardDate}
                </b>
                {val?.event_place?.length > 0 ? (
                  <div
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      alignItems: "left",
                    }}
                  >
                    <img
                      src={func.getStaticImg("/illustration/pin-blue.svg")}
                      style={{ width: 16, height: 16, marginRight: 2 }}
                      alt={"pin"}
                    />
                    <span style={{ fontSize: 12, color: "#6A7481" }}>
                      {val?.event_place ?? "-"}
                    </span>
                  </div>
                ) : null}
              </div>
            </SelectionCityRegistration>
          );
        })}
      </Container>
    </div>
  );
};

export default CityListPopup;
